export default "__VITE_ASSET__DG_Eivk9__"